import Swal from 'sweetalert2';

export const messageWarningButtonCancell = msg => (
    Swal.fire({
        position: 'center',
        icon: 'warning',
        text: msg,
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: '#1b42cd',
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim'
    })
);

export const messageWarning = msg => (
    Swal.fire({
        position: 'center',
        icon: 'warning',
        confirmButtonColor: '#0d730d',
        text: msg,
        showConfirmButton: true,
        timer: 9000
    })
);

export const messageInfo = msg => (
    Swal.fire({
        title: 'Importante',
        html: msg,
        confirmButtonColor: 'green',
        allowOutsideClick: false,
        icon: 'info',
        confirmButtonText: 'OK',
        heightAuto: true
    })
);

export const messageInfoWithButton = async (message, link) => {
    return Swal.fire({
        title: 'Importante',
        html: message,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ir para o novo portal',
        cancelButtonText: 'Ok',
        confirmButtonColor: 'blue',
        cancelButtonColor: 'green',
        allowOutsideClick: false,
        heightAuto: true,
    }).then((result) => {
        if (result.isConfirmed) {
            window.open(link, '_blank'); // Abre o link em uma nova aba
        }
    });
};